import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the page to top on every route change.
 * Prevents new pages from opening at the previous scroll position.
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Use auto behaviour so the change is instant — no jarring smooth scroll
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    // Reset body scroll on Safari/older browsers
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }, [pathname, search]);

  return null;
}
